module.exports = __webpack_public_path__ + "img/1498406647.94ea4eb0.jpg";